{{#each buttons}}
    <button
        id="{{id}}"
        class="btn {{class}} {{#if isPrimary}}btn-primary{{else}}btn-white{{/if}} {{#if disabled}}disabled{{/if}}"
        {{#if isCancel}}data-dismiss="modal"{{/if}} {{#if disabled}}disabled="disabled"{{/if}}>
        {{#if arrowLeft}}<i class="glyphicon glyphicon-chevron-left"></i>{{/if}}
        {{title}}
        {{#if arrowRight}} <i class="glyphicon glyphicon-chevron-right"></i>{{/if}}
    </button>
{{/each}}
